
/* * * * * * * * * * * * * * * *
 * © Toyota Motor North America
 * All rights reserved.
 * * * * * * * * * * * * * * * */

/* tslint:disable:max-line-length */

import { Injectable } from '@angular/core';
// Custom PDF Make version is used because standard version dosent support underline with different thickness
import * as vspecstatic from './vspec-pdf-data-json';
import * as moment from 'moment';
import { decode } from 'html-entities';

// For localhost use the below line and comment the next line
// import * as from '../../../assets/pdfmake.min.js';
// src/assets/pdfmake.min.js
declare var pdfMake: any;

import { isNil } from 'lodash';
import { isNullOrUndefined } from 'util';
import { CurrencyPipe } from '@angular/common';
import { getFullModelText } from 'src/app/shared/components/helpers/util';
import { TOTAL_OPTIONAL_EQUIPMENT } from '../../shared/constants';
import { NOT_APPLICABLE } from '../../shared/constants/app.constants';

@Injectable()
export class VSpecPDFService {
  public brandColor = '#CC0000';
  private isLexus : boolean = false;
  private isGST : boolean = false;
  private htmlRegEx = /(\[([^\]]+)\]|<([^>]+)>)/gi;
  private isSmartPathDealer = false;
  private isOwningDealer = false;
  private canViewDealerAdjustments: boolean = false;

  constructor(private _currencyPipe : CurrencyPipe) {}

  //
  // Write the pdf documents
  //
  getPDFWriter(vehicle,baseMsrpDisclaimer,tsrpDisclaimer,noVin, customerNotes?: string,isPrintPDF?:boolean) {
    // Store the images as part of vehicle object itself, so that manipulation
    // can be done on a single object
    vehicle.vehicleData.carImage = vehicle.carImage;
    vehicle.vehicleData.intColorImage = vehicle.intColorImage;
    vehicle.vehicleData.extColorImage = vehicle.extColorImage;
    vehicle = vehicle.vehicleData;

    //
    // Set Custom Fonts
    //
    pdfMake.vfs = vspecstatic.VSpecPDFData.VSPEC_FONTS;
    //
    // Get Logo Reference
    //
    const logo = vspecstatic.VSpecPDFData.VSPEC_TOYOTA_LOGO.image;

    if(vehicle.brand === 'LEXUS') {
      this.brandColor = '#000000';
      this.isLexus = true;
    }

    if(vehicle.distributorCd && vehicle.distributorCd === 'GST') {
      this.isGST = true;
    }
    //
    // Get Default Fonts
    //
    pdfMake.fonts = this._getFonts();
    //
    // Define the Document Definition
    //
    const documentDefinition = {
      pageSize: {
        height: 1674,
        width: 1294
      },
      styles: vspecstatic.VSpecPDFData.VSPEC_STYLES,
      pageOrientation: 'portrait',
      defaultStyle: {
        font: 'toyota',
      },
      pageMargins: [83, 68, 100, 83],
      content: [
        this.RenderHeader(logo, vehicle, customerNotes,isPrintPDF),
        this.RenderLines(),
        this.RenderModelVehicleSection(vehicle,noVin),
        this.RenderPriceFuelEconomySection(vehicle),
        this.RenderPackagesAccessoriesSection(vehicle),
        this.RenderFeatureSection(vehicle),
        this.RenderFooter(vehicle,baseMsrpDisclaimer,tsrpDisclaimer)
      ]
    };
    const [L,T,R,B] = [30,20,10,10];
     documentDefinition["header"] = (currentPage) => {
      let header= noVin ? `${vehicle.year} ${vehicle.brand} ${vehicle.model.marketingName}` : `${vehicle.year} ${vehicle.brand} ${vehicle.model.marketingName} - ${vehicle.vin}`;
       if (currentPage != 1) {
          return {
            columns: [
              {
                text: [
                  header,
                ],
                bold: true,
                alignment: "left",
                fontSize: 14,
                margin: [L, T, R, B],
              },
            ],
          };
        }
  }
  return pdfMake.createPdf(documentDefinition);
}
  //
  // Render Header
  //
  private RenderHeader(logo, vehicle, customerNotes?: string,isPrintPDF?:boolean) {
    let newLogo = logo;
    let newWidth = 353;
    if(vehicle.brand === 'LEXUS') {
      newLogo = vspecstatic.VSpecPDFData.VSPEC_LEXUS_LOGO.image;
        newWidth = 500;
    }
    if(isPrintPDF) {
      return [
        {
          table: {
            widths: ['52%', '20%','28%'],
            heights: [100,100,100],
            body: [
              [
                { image: newLogo, width: newWidth, height: 99 },
                this.RenderDealerSection(vehicle),
                this.RenderCustomerNotes(customerNotes)
              ]
            ]
          },
          layout: 'noBorders'
        }
      ];
    } else {
      return [
        {
          table: {
            widths: ['52%','48%'],
            heights: [100, 100],
            body: [
              [
                { image: newLogo, width: newWidth, height: 99 },
                this.RenderDealerSection(vehicle)
              ]
            ]
          },
          layout: 'noBorders'
        }
      ];
    }
    
  }

  private RenderFooter(vehicle,baseMsrpDisclaimer,tsrpDisclaimer) {
    let disclaimerText;
    let isGST = false;
    if(vehicle.distributorCd && vehicle.distributorCd === 'GST') {
      isGST = true;
    }
    if(!(this.isSmartPathDealer || isGST)) {
      disclaimerText =  [`* ${baseMsrpDisclaimer}`,
      // {
      //   text: `\n\n${tsrpDisclaimer}`
      // },
      {
        text: `\n\nToyotaCare, which covers normal factory scheduled maintenance for 2 years or 25,000 miles, whichever comes first, is included as part of the sales price of the vehicle for qualifying buyers. See participating dealer for eligibility and coverage details.`
      },
      {
        text: `\n\nDisclaimer: This document is not meant to replace or substitute the actual window sticker on the vehicle. Toyota Motor Sales, U.S.A., Inc. is not responsible and disclaims any liability for inaccuracies. Please contact your dealer with any questions or if you require additional information.`
      },
    ];
    }
    else {
    disclaimerText =  [`* ${baseMsrpDisclaimer}`,
      {
        text: `\n\nToyotaCare, which covers normal factory scheduled maintenance for 2 years or 25,000 miles, whichever comes first, is included as part of the sales price of the vehicle for qualifying buyers. See participating dealer for eligibility and coverage details.`
      },
      {
        text: `\n\nDisclaimer: This document is not meant to replace or substitute the actual window sticker on the vehicle. Toyota Motor Sales, U.S.A., Inc. is not responsible and disclaims any liability for inaccuracies. Please contact your dealer with any questions or if you require additional information.`
      },
    ];
    }
    if (this.isLexus) {
      disclaimerText = [`\n*${vehicle.year} Manufacturer’s Suggested Retail Price, excludes the Delivery, Processing and Handling Fee, taxes, license, title and available or regionally required equipment. Actual Dealer price may vary. Pricing, specifications, fuel economy, standard features and available equipment are based on information available when this page was produced and subject to change without notice.`,
        {
          text: `\n\nDisclaimer: This document is not meant to replace or substitute the actual window sticker on the vehicle. Toyota Motor Sales, U.S.A., Inc. is not responsible and disclaims any liability for inaccuracies. Please contact your dealer with any questions or if you require additional information.`
        },
        {
          text: `\n\nCreate Date: ` + moment().format('MM/DD/YYYY')
        }
      ];
    }
    return [
      {
        style: 'standardFooter',
        table: {
          widths: ['98%'],
          heights: ['auto', 'auto'],
          dontBreakRows: true,
          body: [
            [
              {
                text: ''
              }, // Hack this is to avoid extra blank line on top of the page.
            ],
            [
              {
                text: disclaimerText
              }
            ]
          ]
        },
        layout: {
          border: [false, true, false, false],
          hLineWidth: function (i, node) {
            return i === 0 ? 1 : 0;
          },
          vLineWidth: function (i) {
            return 0;
          },
          hLineColor: function (i, node) {
            return '#979797';
          }
        }
      }
    ];
  }
  
  private RenderCustomerNotes(customerNotes: string) {
    const today: string = new Date().toLocaleString();
    return [
      {
        table: {
          widths: ['100%'],
          heights: ['auto', 'auto', 45],
          body: [
            [
              {
                text: [{text: 'Created: ', bold: true},
                `${today}`],
                border:[false,false,false,false],
                margin:[0,4,0,-6]
              }
            ],
            [
              {
                text: `Customer Notes:`,
                border:[false,false,false,false],
                style:{bold:true}
              }
            ],
            [
              {
                text: customerNotes || "",
                border:[true,true,true,true],
                alignment: 'left',
              }
            ],
            [
              {}
            ],
          ]
        },
        layout: {
          defaultBorder: false,
          hLineColor: function (i, node) {
            return '#CCCCCC'
          },
          vLineColor: function (i, node) {
            return '#CCCCCC'
          },
        }
      }
    ];
   }
  //
  // Render Dealer Section
  //
  private RenderDealerSection(vehicle) {
    let phoneNumber = '';
    if (!!vehicle.dealerDetails && !!vehicle.dealerDetails.phone) {
      phoneNumber = vehicle.dealerDetails.phone.slice(0,3) + '-'
        + vehicle.dealerDetails.phone.slice(3,6) + '-'
        + vehicle.dealerDetails.phone.slice(6);
    }
    return [
      {
        table: {
          widths: ['*'],
          heights: [25, 25, 25],
          body: [
            [
              {
                text: `${vehicle.dealerDetails.dealerName}`,
                style: 'dealername'
              }
            ],
            [
              {
                text: `${vehicle.dealerDetails.address}
                ${vehicle.dealerDetails.city} ${vehicle.dealerDetails.state} ${vehicle.dealerDetails.zip}`,
                style: 'address'
              }
            ],
            [
              {
                text: phoneNumber,
                style: 'address'
              }
            ],
          ]
        },
        layout: 'noBorders'
      }
    ];
  }
  //
  // Render Header Lines
  //
  private RenderLines() {
    return [
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 20,
            x2: 1128,
            y2: 20,
            lineColor: this.brandColor,
            lineWidth: 5
          },
          {
            type: 'line',
            x1: 548,
            y1: -112,
            x2: 548,
            y2: 0,
            lineColor: '#CCCCCC',
            lineWidth: 1
          }
        ]
      }
    ];
  }
  //
  // Show Model Vehicle Section
  //
  private RenderModelVehicleSection(vehicle,noVin?:boolean) {
    return [
      {
        style: 'standardTable',
        table: {
          widths: ['49%', '2%', '49%'],
          heights: ['auto', 'auto', 'auto'],
          body: [
            [
              this.RenderVehicleModelSection(vehicle,noVin),
              [{text: ''}],
              this.RenderVehicleSection(vehicle)
            ]
          ]
        },
        layout: 'noBorders'
      }
    ];
  }
  // Helper to get format the vehicle model information properly, heading is bold and value is light
  private _getVehicleModelInformation(heading, value,hideVin?:boolean) {
    return hideVin ? [{}] : [{ text: [`${heading}: `, { text: `${value}`, style: 'vehicledetails' }] }];
  }
  //
  // Section: Model
  //
  private RenderVehicleModelSection(vehicle,noVin?:boolean) {
    return {
      table: {
        style: 'standardTable',
        widths: ['*'],
        heights: ['*'],
        body: [
          [
            {
              style: 'standardVehicle',
              table: {
                widths: ['auto', '*'],
                heights: [50, 'auto'],
                body: [
                  [
                    {
                      text: `${vehicle.year}`,
                      style: 'modelyear'
                    },
                    {
                      text: ` ${this._decodeHTML(vehicle.marketingSeries)}`,
                      style: 'modelname'
                    }
                  ],
                  [
                    {
                      colSpan: 2,
                      text: this._decodeHTML(vehicle.model.marketingName),
                      style: 'modeldescription'
                    }
                  ]
                ]
              },
              layout: 'noBorders'
            }
          ],
          [
            {
              style: 'vehicledetailsHeading',
              table: {
                widths: ['*'],
                body: [
                  this._getVehicleModelInformation('Model', getFullModelText(vehicle)),
                  this._getVehicleModelInformation('VIN', vehicle.vin,noVin),
                  this._getVehicleModelInformation('Stock', isNil(vehicle.stockNum)
                  ? '' : vehicle.stockNum),
                  // this._getVehicleModelInformation('Exterior', this._decodeHTML(vehicle.extColor.marketingName)),
                  // this._getVehicleModelInformation('Interior', this._decodeHTML(vehicle.intColor.marketingName)),
                  this._getVehicleModelInformation('Engine', this._decodeHTML(vehicle?.engine?.name)),
                  this._getVehicleModelInformation('Transmission', this._decodeHTML(vehicle?.transmission?.transmissionType))
                ]
              },
              layout: 'noBorders'
            }
          ]
        ]
      },
      layout: 'noBorders'
    };
  }
  //
  // Render: Vehicle Section
  //
  private RenderVehicleSection(vehicle) {
    let carImageWidth = this.isLexus ? [600,500] : [591, 242];
    return {
      table: {
        widths: ['100%'],
        heights: ['auto'],
        body: [
          [
            {
              image: vehicle.carImage,
              fit: carImageWidth,
              alignment: 'center'
            }
          ],
          this.RenderVehicleInteriorExteriorInformation(vehicle)
        ]
      },
      layout: 'noBorders'
    };
  }

  private RenderVehicleInteriorExteriorInformation(vehicle) {
    let colorHexCd = vehicle?.extColor?.colorHexCd?.split('|')[0];    
    const out = [
      {
        table: {
          widths: [30, 200, 30, 200],
          body: [
            [
              {
                table: {
                  heights: [28],
                  widths: [28],
                  body: [
                    [
                      (!isNil(colorHexCd) && colorHexCd !== '') ?
                      { fillColor: '#' + colorHexCd, text: '' }
                      : {
                        image: vehicle.extColorImage,
                        width: 36,
                        height: 35,
                        margin: [-4, -2, 0, -4]
                      }
                    ]
                  ]
                },
                layout: {
                  hLineColor: function (i, node) {
                    return 'light-gray';
                  },
                  vLineColor: function (i, node) {
                    return 'light-gray';
                  }
                }
              },
              {
                table: {
                  widths: ['100%'],
                  heights: ['auto', 'auto'],
                  body: [
                    [{ text: 'EXTERIOR', style: 'colortypelabel' }],
                    [{
                      text: this._decodeHTML(vehicle.extColor.marketingName),
                      style: 'colornamelabel'
                    }],
                  ]
                },
                layout: 'noBorders'
              },
              {
                table: {
                  heights: [28],
                  widths: [28],
                  body: [
                    [
                      {
                        image: vehicle.intColorImage,
                        width: 36,
                        height: 32,
                        margin: [-4, -2, 0, -4]
                      }
                    ]
                  ]
                },
                layout: {
                  hLineColor: function (i, node) {
                    return 'light-gray';
                  },
                  vLineColor: function (i, node) {
                    return 'light-gray';
                  }
                }
              },
              {
                table: {
                  widths: ['100%'],
                  heights: [13, 'auto'],
                  body: [
                    [{ text: 'INTERIOR', style: 'colortypelabel' }],
                    [{
                      text: this._decodeHTML(vehicle.intColor.marketingName),
                      style: 'colornamelabel'
                    }],
                  ]
                },
                layout: 'noBorders'
              },
            ]
          ]
        },
        layout: 'noBorders'
      }
    ];
    return out;
  }
  //
  // Render: Price & Fuel Economy Section
  //
  private RenderPriceFuelEconomySection(vehicle) {
    return [
      {
        table: {
          widths: ['50%', '50%'],
          heights: ['auto', 'auto'],
          body: [
            [
              this.RenderPricingSection(vehicle),
              (!this.isNull(vehicle.mpge) && !this.isNull(vehicle.mpg)) ? this.RenderFuelEconomySectionHybrid(vehicle) : (!this.isNull(vehicle.mpg)) ?
                this.RenderFuelEconomySectionGas(vehicle) : this.RenderFuelEconomySectionElectric(vehicle)
            ]
          ]
        },
        layout: 'noBorders'
      }
    ];
  }
  //
  // Render: Pricing
  //

  public isNull(data) {
    if(data === null || !data ) {
      return true;
    } else {
      return false;
    }
  }

  private RenderPricingSection(vehicle) {
    const styles = vehicle.brand === 'LEXUS' ? ['pricelabel','lexusColor'] : 'pricelabel';
    const msrpStyles = vehicle.brand === 'LEXUS' ? 'msrpLexuslabel' : 'msrplabel';
    let factoryaccessoriesTotalPrice = 0;
    vehicle.options.forEach( res => {
      if(res.optionType === 'F' && res.msrp) {
        factoryaccessoriesTotalPrice = factoryaccessoriesTotalPrice + res.msrp;
      }
    });
    let portaccessoriesTotalPrice = 0;
    vehicle.options.forEach( res => {
      if(res.optionType === 'P' && res.msrp) {
        portaccessoriesTotalPrice = portaccessoriesTotalPrice + res.msrp;
      }
    });
    let distributoraccessoriesTotalPrice = 0;
    vehicle.options.forEach( res => {
      if(res.optionType === 'L' && res.msrp) {
        distributoraccessoriesTotalPrice = distributoraccessoriesTotalPrice + res.msrp;
      }
    });
    let dealerInstalledaccessoriesTotalPrice = 0;
    vehicle.options.forEach( res => {
      if(res.optionType === 'D' && res.dealerSellingPrice) {
        dealerInstalledaccessoriesTotalPrice = dealerInstalledaccessoriesTotalPrice + res.dealerSellingPrice;
      }
    });
   this.isSmartPathDealer =  JSON.parse(localStorage.getItem('smartpathdealer'));
   this.isOwningDealer = vehicle.dealerCd === vehicle.dealerDetails.dealerCode;

    let dealerAdjustmentsPrice;
    let dealerAdjustmentsPriceCal: number;

    if (vehicle.price.advertizedPrice !== NOT_APPLICABLE && vehicle.price.advertizedPrice > 0) {
      dealerAdjustmentsPriceCal = (vehicle.price.advertizedPrice) - (vehicle.price.totalMsrp);
    }
    

    if(this.isSmartPathDealer && this.isOwningDealer && dealerAdjustmentsPriceCal) {
      dealerAdjustmentsPrice =  this._setPricing(
        'Dealer Adjustments',
        'vehiclepricelabel',
        dealerAdjustmentsPriceCal,
        'vehiclepricedoller'
      ) ;
    }
    const msrpLabel = this.isLexus ? 'Vehicle Base Model (MSRP *)' : 'Base MSRP *'
    let body =  [
      [
        {
          text: 'PRICE',
          style: styles,
          colSpan: 2
        },
        { text: '' }
      ],
      this._setPricing(
        msrpLabel,
        'vehiclepricelabel',
        vehicle.price.baseMsrp,
        'vehiclepricedoller'
      ),
      this._setPricing(
        'Factory Installed Packages & Accessories',
        'vehiclepricelabel',
        factoryaccessoriesTotalPrice,
        'vehiclepricedoller'
      ) ,
      this._setPricing(
        'Distributor Installed Packages & Accessories',
        'vehiclepricelabel',
        distributoraccessoriesTotalPrice,
        'vehiclepricedoller'
      ),
      this._setPricing(
        'Dealer Installed Packages & Accessories',
        'vehiclepricelabel',
        dealerInstalledaccessoriesTotalPrice,
        'vehiclepricedoller'
      ),
      this._setPricing(
        'Port Installed Packages & Accessories',
        'vehiclepricelabel',
        portaccessoriesTotalPrice,
        'vehiclepricedoller'
      ),
      this._setPricing(
        'Delivery Processing and Handling',
        'vehiclepricelabel',
        vehicle.price.dph,
        'vehiclepricedoller'
      )
    ]
    if(dealerAdjustmentsPrice) {
      if(this.isSmartPathDealer){
        body.push(dealerAdjustmentsPrice,
          this._setPricing(
            'Total Advertised Price',
             msrpStyles,
            vehicle.price.advertizedPrice,
            'msrpvalue'
          ));
      } else {
        body.push(dealerAdjustmentsPrice,
          this._setPricing(
            'Total Price',
             msrpStyles,
            vehicle.price.totalMsrp,
            'msrpvalue'
          ));
      }
    } else {
      if(this.isSmartPathDealer){
        body.push(
          this._setPricing(
            'Total Advertised Price',
             msrpStyles,
            this.isOwningDealer ? (vehicle.price.advertizedPrice !== NOT_APPLICABLE ? vehicle.price.advertizedPrice : vehicle.price.totalMsrp) : vehicle.price.totalMsrp,
            'msrpvalue'
          ));
      }  else {
        body.push(
          this._setPricing(
            this.isGST || this.isLexus ? 'Total Price' : 'Total Suggested Retail Price',
             msrpStyles,
            vehicle.price.totalMsrp,
            'msrpvalue'
          ));
      }
    }

    const filteredBody = body.filter((res: any[]) => !res.some(resp => resp.text === '$0.00') || res.some(resp => resp.text === 'Delivery Processing and Handling'));

    return {
      style: 'fuelEconomy',
      table: {
        widths: [330, 185],
        heights: [32],
        body: filteredBody
      },
      layout: {
        paddingLeft: function (i, node) {
          return 0;
        },
        paddingRight: function (i, node) {
          return 0;
        },
        paddingTop: function (i, node) {
          return i === 1 ? 14 : 5;
        },
        paddingBottom: function (i, node) {
          return i === 0 ? 0 : 5;
        },
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 0;
          }
          return i === node.table.headerRows ? 1 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === 1 || i === node.table.body.length - 1
            ? '#979797'
            : '#cccccc';
        }
      }
    };
  }
  private _getFuelEconomyTableLayout() {
    return {
      // border: [true, true, true, true],
      paddingLeft: function (i, node) {
        return 0;
      },
      paddingRight: function (i, node) {
        return 0;
      },
      paddingTop: function (i, node) {
        return i === 2 ? -15 : 0;
      },
      paddingBottom: function (i, node) {
        return i === 0 ? 0 : 0;
      },
      hLineWidth: function (i, node) {
        //   if (i === 0 || i === node.table.body.length) {
        //     return 0;
        //   }
        return i === 1 ? 1 : 0;
      },
      vLineWidth: function (i) {
        return 0;
      },
      hLineColor: function (i, node) {
        return '#979797';
      }
    };
  }
  //
  // Render: Fuel Economy
  //
  private RenderFuelEconomySectionGas(vehicle) {
    const styles = vehicle.brand === 'LEXUS' ? ['pricelabel','lexusColor'] : 'pricelabel';
    return {
      style: 'fuelEconomy',
      table: {
        widths: [75, 135, 80, '*'],
        heights: [32, 50, 32],
        body: [
          [
            { text: 'FUEL ECONOMY', style: styles, colSpan: 4 },
            {},
            {},
            {}
          ],
          this.RenderFuelEconomyMpgSection(vehicle),
          [
            {
              text: 'Combined City/Hwy',
              style: 'economytypeslabel',
              colSpan: 2,
              margin: [0, 0, 0, 0]
            },
            {},
            { text: 'City', style: 'economytypeslabel' },
            { text: ' Highway', style: 'economytypeslabel' }
          ]
        ]
      },
      layout: this._getFuelEconomyTableLayout()
    };
  }

  private RenderFuelEconomySectionElectric(vehicle) {
    const styles = vehicle.brand === 'LEXUS' ? ['pricelabel','lexusColor'] : 'pricelabel';
    return {
      style: 'fuelEconomy',
      table: {
        widths: [75, 135, 100, '*'],
        heights: [32, 50, 32],
        body: [
          [
            { text: 'FUEL ECONOMY', style: styles, colSpan: 4 },
            {},
            {},
            {}
          ],
          this.RenderFuelEconomyMpgeSection(vehicle),
          [
            {
              text: 'Combined City/Hwy',
              style: 'economytypeslabelNA',
              colSpan: 2,
              margin: [0, 0, 0, 0]
            },
            {},
            { text: 'City', style: 'economytypeslabelNA' },
            { text: ' Highway', style: 'economytypeslabelNA'}
          ]
        ]
      },
      layout: this._getFuelEconomyTableLayout()
    };
  }
  //
  // Render: Fuel Economy
  //
  private RenderFuelEconomySectionHybrid(vehicle) {
    const styles = vehicle.brand === 'LEXUS' ? ['standardequipmentlabel','lexusColor'] : 'standardequipmentlabel';
    return {
      style: 'fuelEconomy',
      table: {
        widths: [75, 135, 80, '*'],
        heights: [32, 50, 32],
        body: [
          [
            { text: 'FUEL ECONOMY', style: styles, colSpan: 4 },
            {}
          ],
          this.RenderFuelEconomyMpgSectionHybrid(vehicle)
        ]
      },
      layout: this._getFuelEconomyTableLayout()
    };
  }
  private RenderFuelEconomyMpgSectionHybrid(vehicle) {
    const gasPumpImage = vspecstatic.VSpecPDFData.VSPEC_GAS_PUMP.image;
    const hybridGasPumpImage = vspecstatic.VSpecPDFData.VSPEC_GAS_PUMP_HYBRID_IMAGE.image;
    let combinedmpg : string;
    if(vehicle.mpg && vehicle.mpg.combined) {
    combinedmpg = vehicle.mpg.combined;
    } else {
      combinedmpg = '';
    }
    return [
      {
        colSpan: 4,
        style: 'fuelEconomyMpg',
        table: {
          widths: [35, 132, 20, 1, 70, 35, 200],
          heights: [100],
          body: [
            [
              { image: gasPumpImage, fit: [100, 65], style: 'gasPump' },
              {
                text: [
                  { text: combinedmpg, style: 'combinedeconomy' },
                  { text: 'MPG' }
                ]
              },
              { text: '' },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 10,
                    y1: 30,
                    x2: 10,
                    y2: 118,
                    lineColor: '#CCCCCC',
                    lineWidth: 1
                  }
                ]
              },
              { text: '' },
              { image: hybridGasPumpImage, fit: [100, 65], style: 'gasPumphybrid' },
              {
                text: [
                  { text: vehicle.mpge.combined, style: 'combinedeconomy' },
                  { text: 'MPGe' }
                ]
              },
            ]
          ]
        },
        layout: {
          defaultBorder: false,
          paddingTop: function (i, node) {
            return -8;
          },
          paddingBottom: function (i, node) {
            return 0;
          }
        }
      },
      {},
      {},
      {}
    ];
  }

  private RenderFuelEconomyMpgSection(vehicle) {
    const gasPumpImage = vspecstatic.VSpecPDFData.VSPEC_GAS_PUMP.image;
      let combinedmpg : string;
      let citympg : string;
      let highwaympg : string;
    if(vehicle.mpg) {
     combinedmpg = vehicle.mpg.combined;
     citympg = vehicle.mpg.city;
     highwaympg = vehicle.mpg.highway;

    } else {
      combinedmpg = '';
      citympg = '';
      highwaympg = '';
    }
    return [
      {
        colSpan: 4,
        style: 'fuelEconomyMpg',
        table: {
          widths: [35, 132, 1, 75, 1, 'auto'],
          heights: [100],
          body: [
            [
              { image: gasPumpImage, fit: [100, 65], style: 'gasPump' },
              {
                text: [
                  { text: combinedmpg, style: 'combinedeconomy' },
                  { text: 'MPG' }
                ]
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: -2,
                    y1: 30,
                    x2: -2,
                    y2: 125,
                    lineColor: '#CCCCCC',
                    lineWidth: 1
                  }
                ]
              },
              {
                text: [
                  { text: `\n${citympg}`, style: 'cityeconomy' },
                  { text: 'MPG' }
                ]
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 70,
                    x2: 0,
                    y2: 123,
                    lineColor: '#CCCCCC',
                    lineWidth: 1
                  }
                ]
              },
              {
                text: [
                  { text: `\n${highwaympg}`, style: 'cityeconomy' },
                  { text: 'MPG' }
                ]
              }
            ]
          ]
        },
        layout: {
          defaultBorder: false,
          paddingTop: function (i, node) {
            return i === 0 ? -8 : -50;
          },
          paddingBottom: function (i, node) {
            return 0;
          }
        }
      },
      {},
      {},
      {}
    ];
  }

  private RenderFuelEconomyMpgeSection(vehicle) {
    const hybridGasPumpImage = vspecstatic.VSpecPDFData.VSPEC_GAS_PUMP_HYBRID_IMAGE.image;
      let combinedmpge : string;
      let citympge : string;
      let highwaympge : string;
    if(vehicle.mpge) {
     combinedmpge = vehicle.mpge.combined;
     citympge = vehicle.mpge.city;
     highwaympge = vehicle.mpge.highway;

    } else {
      combinedmpge = '';
      citympge = '';
      highwaympge = '';
    }
    return [
      {
        colSpan: 4,
        style: 'fuelEconomyMpg',
        table: {
          widths: [35, 170, 1, 100, 1, 'auto'],
          heights: [100],
          body: [
            [
              { image: hybridGasPumpImage, fit: [100, 65], style: 'gasPumphybrid' },
              {
                text: [
                  { text: combinedmpge ? combinedmpge : NOT_APPLICABLE, style: combinedmpge ? 'combinedeconomy' : 'combinedeconomyNA' },
                  { text: 'MPGe' }
                ]
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: -2,
                    y1: 30,
                    x2: -2,
                    y2: 125,
                    lineColor: '#CCCCCC',
                    lineWidth: 1
                  }
                ]
              },
              {
                text: [
                  { text: `\n${citympge}`, style: 'cityeconomy' },
                  { text: 'MPGe' }
                ]
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 70,
                    x2: 0,
                    y2: 123,
                    lineColor: '#CCCCCC',
                    lineWidth: 1
                  }
                ]
              },
              {
                text: [
                  { text: `\n${highwaympge}`, style: 'cityeconomy' },
                  { text: 'MPGe' }
                ]
              }
            ]
          ]
        },
        layout: {
          defaultBorder: false,
          paddingTop: function (i, node) {
            return i === 0 ? -8 : -50;
          },
          paddingBottom: function (i, node) {
            return 0;
          }
        }
      },
      {},
      {},
      {}
    ];
  }

  //
  //
  //
  private getFeatureList(featureLabel, featureValue) {
    const leftList = [];
    const rightList = [];

    let index = 0;
    featureValue.map(e => this._decodeHTML(e)).map(e => {
      if (index++ % 2 === 0) { leftList.push(e); } else { rightList.push(e); }
    });
    return {
      type: 'none',
      ul: [
        {
          text: featureLabel,
          style: 'standardfeatureslabel'
        },
        {
          type: 'none',
          ul: [
            [
              {
                columns: [
                  { ul: leftList, style: 'standardfeatures' },
                  { ul: rightList, style: 'standardfeatures' }
                ]
              }
            ]
          ]
        },
        {
          text: ' ', // hack for add spacing at the end of features list
          style: 'standardfeatureslabel'
        },
      ]
    };
  }

  private RenderFeatureSection(vehicle) {
    const  styles = vehicle.brand === 'LEXUS' ? ['standardequipmentlabel','lexusColor'] : 'standardequipmentlabel';
    let exteriorDimensions =  vehicle.standardOptions.exteriorDimensions || [];
    exteriorDimensions = exteriorDimensions && exteriorDimensions.length ? exteriorDimensions.map( e=> `${e.name} ${e.value}`) : [];
    return [
      {
        style: 'standardTable',
        table: {
          widths: ['*'],
          heights: [25, 'auto'],
          dontBreakRows: true,
          body: [
            [
              {
                text: 'FEATURES',
                style: styles
              }
            ],
            [
              {
                text: '', // Hack this is to fix the additional line that gets repeated on every page
                style: 'standardequipmentlabel'
              }
            ]
          ]
        },
        layout: {
          defaultBorder: true,
          paddingLeft: function (i, node) {
            return 0;
          },
          hLineWidth: function (i, node) {
            return i === 1 ? 1 : 0;
          },
          vLineWidth: function (i) {
            return 0;
          },
          hLineColor: function (i, node) {
            return '#979797';
          },
          paddingTop: function (i, node) {
            return i === 1 ? 15 : 5;
          },
          paddingBottom: function (i, node) {
            return i === 0 ? 0 : 5;
          },
        }
      },
      !!vehicle.standardOptions.mechanicalAndPerformance
        && vehicle.standardOptions.mechanicalAndPerformance.length ? [
        this.getFeatureList(
          'Mechanical & Performance',
          vehicle.standardOptions.mechanicalAndPerformance
        )
      ] : '',
      [this._processLexusStandardEquipments(vehicle)],
      vehicle.standardOptions.steering
        && vehicle.standardOptions.steering.length ? [this.getFeatureList('Steering', vehicle.standardOptions.steering)] : '',
      vehicle.standardOptions.exterior
        && vehicle.standardOptions.exterior.length ? [this.getFeatureList('Exterior', vehicle.standardOptions.exterior)] : '',
      exteriorDimensions.length ? [this.getFeatureList('Exterior Dimensions', exteriorDimensions)] : '',
      vehicle.standardOptions.interior
        && vehicle.standardOptions.interior.length ? [this.getFeatureList('Interior', vehicle.standardOptions.interior)] : '',
      vehicle.standardOptions.audioMultimedia
        && vehicle.standardOptions.audioMultimedia.length ? [this.getFeatureList('Audio Multimedia', vehicle.standardOptions.audioMultimedia)] : '',
      vehicle.standardOptions.toyotaCare
        && vehicle.standardOptions.toyotaCare.length ? [this.getFeatureList('ToyotaCare', vehicle.standardOptions.toyotaCare)] : '',
      vehicle.standardOptions.offHighway
        && vehicle.standardOptions.offHighway.length ? [this.getFeatureList('Off-Highway', vehicle.standardOptions.offHighway)] : '',
      vehicle.standardOptions.safetyAndConvenience
        && vehicle.standardOptions.safetyAndConvenience.length ? [
        this.getFeatureList(
          'Safety & Convenience',
          vehicle.standardOptions.safetyAndConvenience
        )
      ] : '',
      vehicle.standardOptions.connectedServices
        && vehicle.standardOptions.connectedServices.length ? [this.getFeatureList('Connected Services', vehicle.standardOptions.connectedServices)] : '',
    ];
  }

  //
  // Render: RenderPackagesAccessoriesSection
  //
  private RenderPackagesAccessoriesSection(vehicle) {
    const styles = vehicle.brand === 'LEXUS' ? ['standardequipmentlabel','lexusColor'] : 'standardequipmentlabel';
    const vehicleOptions: any[] = [];
    // Section Heading,
    const heading = [
      {
        text: 'INSTALLED PACKAGES & ACCESSORIES',
        style: styles
      },
      {},
      {}
    ];

    const pricingOptions: any[] = [];
    pricingOptions.push(heading);
    vehicle.options.map(option => {
      const pricingLabels: any[] = [];
      pricingLabels.push({
        text: this._decodeHTML(option.marketingName),
        style: 'optionalfeatures',
        border: [false, true, false, false]
      });
      if (option.marketingLongName && option.marketingName !== option.marketingLongName) {
        const data = decode(option.marketingLongName).replace(/<br>/g, '\n');
        if (data.includes('<ol>')) {
          const formatData = data.split('<li>').filter((res,i) => i > 0).map(d => this._decodeHTML(d)).filter(f => f);
          pricingLabels.push(          {
            type: 'none',
            ol: [
              [
                {
                  columns: [
                    { ol: formatData, style: 'standardfeatures' },
                  ]
                }
              ]
            ]
          },);
        } else if (data.includes('<ul>')) {
          const formatText =data.split('<ul>')[0];
          if (formatText) {
            pricingLabels.push({
              text: this.formatMarktingLongName(this._decodeHTML(formatText)),
              style: 'optionalfeaturesdescription',
              border: [false, true, false, false]
            });
          }
          const formatData = data.split('<li>');
          const finalResult = [];
          formatData.forEach((f, index) => {
            if (index > 0) {
              finalResult.push(this._decodeHTML(f));
            }
          })
          pricingLabels.push(          {
            type: 'none',
            ul: [
              [
                {
                  columns: [
                    { ul: finalResult, style: 'optionalfeaturesdescription' },
                  ]
                }
              ]
            ]
          },);
        } else {
          pricingLabels.push({
            text: this.formatMarktingLongName(this._decodeHTML(option.marketingLongName.replace(/<br>/g, '\n'))),
            style: 'optionalfeaturesdescription',
            border: [false, true, false, false]
          });
        }
      }
      let accessoriesPrice;
      if(option.optionType === "D") {
        if(!(this.isSmartPathDealer || this.isGST)){
          accessoriesPrice = '****';
       } else {
        accessoriesPrice = this._formatPrice(option.dealerSellingPrice);
       }
      } else {
        accessoriesPrice = this._formatPrice(option.msrp);
      }
      pricingOptions.push([
        pricingLabels,
        {
          text: this._getOptionType(option.optionType),
          style: 'optionalfeaturesvalue',
          alignment: 'right',
          border: [false, true, false, false]
        },
        {
          text: accessoriesPrice,
          style: 'optionalfeaturesvalue',
          alignment: 'right',
          border: [false, true, false, false]
        }
      ]);
    });

    pricingOptions.push(
      this._setPricing(
        TOTAL_OPTIONAL_EQUIPMENT,
        'optionalfeatures',
        vehicle.price.optTotalMsrp,
        'optionalfeaturesvalue',
        true
      )
    );
    pricingOptions.push(
      this._setPricing(
        'Vehicle Base Model',
        'optionalfeatures',
        vehicle.price.baseMsrp,
        'optionalfeaturesvalue',
        true
      )
    );
    pricingOptions.push(
      this._setPricing(
        'Delivery Processing and Handling',
        'optionalfeatures',
        vehicle.price.dph,
        'optionalfeaturesvalue',
        true
      )
    );
    if(!(this.isSmartPathDealer || this.isGST)) {
      vehicle.options.forEach( res => {
        if(res.optionType === 'D') {
          pricingOptions.push(
            [
              { text: '**** Included in Total Price', style: 'optionalfeatures',  border: [false, false, false, false] },
              { text: '', alignment: 'left', style: 'optionalfeatures' ,border: [false, false, false, false] },
              { text: '', alignment: 'left', style: 'optionalfeatures' ,border: [false, false, false, false] }
            ]
          );
        }
      });
    }
    // pricingOptions.push(
    //   this._setPricing(
    //     'Total MSRP*',
    //     'optionalfeaturesmsrplabel',
    //     vehicle.price.totalMsrp,
    //     'optionalfeaturesmsrpvalue'
    //   )
    // );

    const tableContents = {
      style: 'standardTable',
      table: {
        widths: ['*', 200,200],
        heights: [25, 'auto','auto'],
        body: pricingOptions,
        dontBreakRows: true,
      },
      layout: {
        paddingLeft: function (i, node) {
          return 0;
        },
        paddingTop: function (i, node) {
          return i === 1 ? 20 : 5;
        },
        paddingBottom: function (i, node) {
          return i === 0 ? 0 : 5;
        },
        hLineWidth: function (i, node) {
          if (i === 0) {
            return 0;
          }
          return i === node.table.headerRows ? 0 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return '#979797';
          } else {
            return '#cccccc';
          }
        }
      }
    };

    vehicleOptions.push(tableContents);

    return vehicleOptions;
  }

  private _processLexusStandardEquipments(vehicle) {
    const data = [];
    if(vehicle.brand === 'LEXUS') {
         if(vehicle.standardEquipments && vehicle.standardEquipments.length)  {
              vehicle.standardEquipments.forEach(element => {
  data.push(this.getFeatureList(element.header, element.value));
    });
        }
  }
    return data;
  }

  //
  // Set Pricing Information
  //
  private _setPricing(label, labelStyle, price, priceStyle,isadd?:boolean) {
    return isadd ? [
      { text: label, style: labelStyle, padding: [5, 5, 5, 5] },
      {},
      { text: this._formatPrice(price), alignment: 'right', style: priceStyle }
    ] : [
      { text: label, style: labelStyle, padding: [5, 5, 5, 5] },
      { text: this._formatPrice(price), alignment: 'right', style: priceStyle }
    ];
  }
  //
  // Format Prices
  //

  private _formatPrice(number: any): string {
    if (number === NOT_APPLICABLE) {
      return NOT_APPLICABLE;
    }

    const price: string = this._currencyPipe.transform(number,'$','symbol','1.2-2');
    return `${price}`;
  }
  //
  // Decode Html
  //
  private _decodeHTML(htmlString) {
    return decode(htmlString).replace(this.htmlRegEx, '').replace('‑', '-');
  }
  //
  // Define Fonts
  //
  private _getFonts() {
    return {
      toyota: {
        normal: 'toyotatype-regular.ttf',
        light: 'toyotatype-light.ttf',
        bold: 'toyotatype-bold.ttf',
        italics: 'toyotatype-light.ttf',
        bolditalics: 'toyotatype-semibold.otf'
      },
      toyotalight: {
        normal: 'toyotatype-light.ttf',
        bold: 'toyotatype-bold.ttf',
        italics: 'toyotatype-regularit.ttf',
        bolditalics: 'toyotatype-bookit.ttf'
      },
      toyotasemibold: {
        normal: 'toyotatype-semibold.otf',
        bold: 'toyotatype-bold.ttf',
        italics: 'toyotatype-regularit.ttf',
        bolditalics: 'toyotatype-bookit.ttf'
      },
      toyotabook: {
        normal: 'toyotatype-book.ttf',
        bold: 'toyotatype-bold.ttf',
        italics: 'toyotatype-light.ttf',
        bolditalics: 'toyotatype-semibold.otf'
      },
      helvetica: {
        normal: 'HelveticaNeueW01-45Light.ttf',
        bold: 'HelveticaNeueW01-75Bold.ttf',
        italics: 'HelveticaNeueW01-65Medium.ttf',
        bolditalics: 'HelveticaNeueW01-75Bold.ttf'
      }
    };
  }

  private _getOptionType(data) {
   if(data === 'F') {
     return 'FIO';
   } else if(data === 'P') {
     return 'PIO';
   } else if(data === 'L') {
    return 'LIO';
  } else if(data === 'D') {
    return 'DIO';
  }
  }


  private formatMarktingLongName(marketingLongName: string): string {
    if (!isNil(marketingLongName)) {
      let formattedName = marketingLongName
        .replace(/\.\•/g, '. ')
        .replace(/\•/g, '. ')
        .trim();
      if (formattedName.lastIndexOf('.') !== formattedName.length - 1) {
        formattedName = formattedName + '.';
      }
      return formattedName;
    } else {
      return marketingLongName;
    }
  }
}
